import { useEffect, useState } from "react";
import BoxPrenotationByBooking from "./boxPrenotationByBooking"
import { HttpService } from "../../services/HttpService";
import { useSelector } from "react-redux";
import { updateSelectedBookingId } from "../../redux/reducer/prenotationViewReducer";
import { useAppDispatch } from "../../redux";
import PopUpNote from "../popUpNote";
import { hasModules } from "../../utils/helpers";

const ListingPrenotationByBookingId = (props: any) => {
  // internal state
  const [bookings, setBookings] = useState([]);
  const [success, setSuccess] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [bookingEventId, setBookingEventId] = useState("");
  const [showPopUpNote, setShowPopUpNote] = useState(false);
  const [attendanceFullName, setAttendanceFullName] = useState("");

  // redux state
  const { selectedTimeslotId, selectedBookingId, selectedDay } = useSelector((state: any) => state.prenotationView);
  const { eventId, user } = useSelector((state: any) => state.login);
  const dispatch = useAppDispatch();

  /**
   * Update bookings in the list, fetching from server.
   */
  const loadBookings = () => {

    if (!selectedTimeslotId) {
      return;
    }
    let endPointUrl = `t4event/api/v01/event/${eventId}/timeslot/${selectedTimeslotId}/bookings`

     if(hasModules(user,'FEDERFARMA_DOCTOR')){
       endPointUrl = `t4event/api/v01/federfarma/doctor/day/${selectedDay}/time/${selectedTimeslotId}/bookings`
     }
    
    HttpService.get(`${process.env.REACT_APP_API}/${endPointUrl}`).then(response => {
      const incomingBookings = response.data;
      setBookings(incomingBookings);

      // if no booking specified, select the first one
      if (!selectedBookingId && incomingBookings.length > 0) {
        dispatch(updateSelectedBookingId(incomingBookings[0]._id))
      }
    }).catch(error => {
      console.log(error)
      setBookings([])
    });
  };

  /**
   * Close PopUp Note.
   */
  const closePopUpNote = () => {
    setBookingId("");
    setAttendanceFullName("");
    setBookingEventId("")
    setShowPopUpNote(false)
  }
  /**
   * Open PopUp Note.
   */
  const openPopUpNote = (booking: string, attendanceFullName: string,bookingEventId:string) => {
    setBookingId(booking);
    setAttendanceFullName(attendanceFullName);
    setBookingEventId(bookingEventId)
    setShowPopUpNote(true);
  }

  /**
   * Load timeslot bookings when selectedTimeslotId changes.
   */
  useEffect(() => {
    loadBookings();
  }, [selectedTimeslotId]);

  const isMeetingPassed = (booking: any) => {
    const closingTime = new Date(booking.closingTime).getTime()
    return Boolean(!isNaN(closingTime) && Date.now() > closingTime)
  }

  return (
    <>
      {/* {((success != "") ?
        <SuccessMessageBox successMessage={success} />
        :
        <></>
      )} */}
      <div className="mt-4 scrollY">
        {bookings?.map((booking: any, index: any) => (
          <div key={booking._id} id={"booking" + booking._id}>
            <BoxPrenotationByBooking
              isMeetingPassed={isMeetingPassed(booking)}
              changeInfoOldAttendances={props?.changeInfoOldAttendances}
              openBox={booking._id === selectedBookingId}
              // setSuccess={setSuccess}
              attendances={booking.attendances}
              openPopUpNote={openPopUpNote}
              updateBookings={loadBookings} // trigger update after move or delete
            />
          </div>
        ))}
      </div>
      <PopUpNote 
        bookingId={bookingId} 
        eventId={bookingEventId}
        attendanceFullName={attendanceFullName} 
        show={showPopUpNote} 
        closePopUp={() => (closePopUpNote())} 
      />
    </>

  )
}

export default ListingPrenotationByBookingId